/**
 * Page title block. No banded background or divider — the title, its gold rule,
 * and the body read as one continuous column, which keeps the gap between
 * heading and content tight. Matches the homepage treatment.
 */
export default function PageHeader({ title, intro }: { title: string; intro?: string }) {
  return (
    <div className="mx-auto w-full px-4 pt-7 sm:px-6 lg:px-10 lg:pt-8 xl:px-14">
      <h1 className="font-display text-2xl font-bold tracking-tight text-gold-700 sm:text-3xl">
        {title}
      </h1>
      <div className="mt-3.5 h-[3px] w-14 rounded-full bg-linear-to-r from-gold-500 to-gold-300" />
      {intro && <p className="mt-4 max-w-2xl text-lg leading-relaxed text-ink-900">{intro}</p>}
    </div>
  );
}
